<template>
  <div ref="privacy" class="privacy-policy">
    <a-modal
      :visible="true"
      :footer="null"
      :get-container="() => ($refs.privacy as HTMLElement)"
      centered
      @cancel="cancelM"
    >
      <template #closeIcon>
        <img class="icon-close" src="@assets/svgs/preload-icon-popper-close.svg" alt="" />
      </template>
      <div class="title">{{ $t('owork_base.owork_user_policy.title') }}</div>
      <PrivacyPolicyWeb v-if="useElectron() === undefined" />
      <PrivacyPolicyPC v-else />
      <div class="bottom-shadow"></div>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
  import PrivacyPolicyPC from './PrivacyPolicyPC.vue'
  import PrivacyPolicyWeb from './PrivacyPolicyWeb.vue'
  import { useElectron } from '@core/compositions/Electron'

  const emit = defineEmits(['cancel-privacy-policy'])

  const cancelM = () => {
    emit('cancel-privacy-policy', false)
  }
</script>

<style lang="stylus" scoped>
  @import '../../styles/settingModal.styl'

  .privacy-policy
    setting-model-style()
    .title
      display inline-block
      rect(100%, 26px)
      line-height 26px
      font-weight bolder_font_weight
      margin-top 23px
      text-align center
      font-size 20px
      margin-bottom 24px
    #privacy-policy-content
      padding 0px 32px 50px
      overflow-y auto
      height 530px

  @import '../../styles/h5Adaptive/settingModal.styl'
</style>
